import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'; 
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ToolTip } from '../icons';
import Modal from '../Modal';
import { formatContentForReact } from '../globalHelpers';

import './Text.scss';

const Text = ({
  children,
  evidence = [],
  className = null,
  noteText = false,
}) => {
  const { t } = useTranslation();
  const [activeEvidenceIndex, setActiveEvidenceIndex] = useState(null);

  const closeModal = () => setActiveEvidenceIndex(null);

  const markdownComponents = useMemo(() => ({
    table: ({ children: tableChildren }) => (
      <div className="edu-table__container">
        <table className="edu-table">{tableChildren}</table>
      </div>
    ),

    del: ({ children: delChildren }) => {
      const rawText = Array.isArray(delChildren) 
        ? delChildren.join('') 
        : delChildren?.toString() || '';
        
      const evidenceRegex = /evidence-(\d+)$/;
      const match = rawText.match(evidenceRegex);

      if (match) {
        const evidenceNumber = parseInt(match[1], 10) - 1;
        const evidenceObj = evidence[evidenceNumber];
        const modalContent = evidenceObj?.content;

        return (
          <span className="edu-text__evidence-wrapper">
            <button
              type="button"
              className="edu-text__evidence-button"
              onClick={() => setActiveEvidenceIndex(evidenceNumber)}
              title={t('evidenceButton.title', 'View Evidence')}
            >
              <ToolTip className="edu-text__evidence-icon" />
            </button>
            <Modal
              isOpen={activeEvidenceIndex === evidenceNumber}
              onRequestClose={closeModal}
            >
              {modalContent ? formatContentForReact(modalContent) : null}
            </Modal>
          </span>
        );
      }
      return <del>{delChildren}</del>;
    }
  }), [evidence, activeEvidenceIndex, t]);

  return (
    <div className={classNames(className, 'edu-text', { 'edu-text--note': noteText })}>
      {/* 2. Add remarkPlugins here */}
      <ReactMarkdown 
        components={markdownComponents} 
        remarkPlugins={[remarkGfm]}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
};

Text.propTypes = {
  children: PropTypes.string.isRequired,
  evidence: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string
    })
  ),
  className: PropTypes.string,
  noteText: PropTypes.bool,
};

export default Text;
